import script from "./Municipality.vue?vue&type=script&setup=true&lang=ts"
export * from "./Municipality.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__